import React, { useState } from "react";
import './contact-us.css';
import { useForm, ValidationError } from '@formspree/react';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';

function Contact() {
    const [ref, isVisible] = useScrollAnimation(0.2);
    const [state, handleSubmit] = useForm(process.env.REACT_APP_FORMSPREE_ID || "mpzvqryn");
    const [errors, setErrors] = useState({});

    const validateForm = (e) => {
        const formData = new FormData(e.target);
        const name = formData.get('name');
        const email = formData.get('email');
        const subject = formData.get('subject');
        const message = formData.get('message');
        
        const newErrors = {};
        
        if (!name || name.trim().length < 2) {
            newErrors.name = 'Name must be at least 2 characters long';
        }
        
        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            newErrors.email = 'Please enter a valid email address';
        }
        
        if (!subject || subject.trim().length < 3) {
            newErrors.subject = 'Subject must be at least 3 characters long';
        }
        
        if (!message || message.trim().length < 10) {
            newErrors.message = 'Message must be at least 10 characters long';
        }
        
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const onSubmit = (e) => {
        e.preventDefault();
        if (validateForm(e)) {
            handleSubmit(e);
        }
    };

    return (
        <section className={`contact-us fade-in-section ${isVisible ? 'is-visible' : ''}`} id="contact-us" ref={ref}>
            <div className="wrapper contact-us">
                <h1>Contact Us</h1>
                <div className="wrap-form">
                    {state.submitting ? (
                        <div className="loading-state">
                            <div className="spinner"></div>
                            <p>Sending your message...</p>
                        </div>
                    ) : state.succeeded ? (
                        <div className="success-message">
                            <div className="success-icon">✓</div>
                            <h2>Message Sent Successfully!</h2>
                            <p>Thank you for contacting us. We'll get back to you soon.</p>
                        </div>
                    ) : (
                        <form onSubmit={onSubmit}>
                            <label htmlFor="name">Name: </label>
                            <input type="text" id="name" required name="name" />
                            {errors.name && <span className="error-message">{errors.name}</span>}
                            
                            <label htmlFor="email">Email: </label>
                            <input type="email" id="email" name="email" required />
                            {errors.email && <span className="error-message">{errors.email}</span>}
                            <ValidationError
                                prefix="Email"
                                field="email"
                                errors={state.errors}
                            />
                            
                            <label htmlFor="subject">Subject: </label>
                            <input type="text" id="subject" name="subject" required />
                            {errors.subject && <span className="error-message">{errors.subject}</span>}
                            
                            <label htmlFor="textbox">Message: </label>
                            <textarea
                                name="message"
                                id="textbox"
                                placeholder="Enter text here"
                                defaultValue={""}
                            />
                            {errors.message && <span className="error-message">{errors.message}</span>}
                            
                            <button type="submit" disabled={state.submitting}>Send</button>
                        </form>
                    )}
                </div>
            </div>
        </section>
    );

};

export default Contact;